class AddonProduct {
    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} trigger
     */
    constructor(trigger) {

        this.addProduct = !trigger.classList.contains('in-cart-drawer');
        this.dom = {
            trigger,
            text: trigger.querySelector('span')
        }
        this.settings = {
            id: Number(trigger.dataset.variantId),
            isAside: trigger.id.includes('aside')
        }
        this.text = {
            submit: trigger.dataset.textSubmit,
            submitted: trigger.dataset.textSubmitted,
            soldOut: trigger.dataset.textSoldOut
        }

        this.dom.trigger.classList.remove('js-init')

        this.dom.trigger.addEventListener('click', (event) => {
            // debugger
            event.preventDefault();
            this.click();
        })

        this.eventListeners();

    }

    click() {
        if (this.addProduct) {
            this.addToCart();
        }
        else {
            this.removeFromCart();
        }
    }

    /**
     * 
     * @param {object} cartItems 
     * 
     * This checks if the product is in the cart, and changes the text according toits state
     * 
     * Takes an object {items: [{'id': number, 'quantity', number },{'id': number, 'quantity', number }]}
     */
    checkIfInCart({ cartItems = null, errorData = null }) {

        if (cartItems != null) {
            // console.log(`cartItems: `, cartItems);
            // console.log(`this.settings.id: `, this.settings.id);
            const matches = cartItems.items.find(x => x.id === this.settings.id)
            // console.log(`matches: ${ this.settings.id } =`, matches);
            const text = matches ? this.text.submitted : this.text.submit;

            this.dom.text.textContent = text;

            if (matches) {
                this.addProduct = false;
            } else {
                this.addProduct = true;
            }

        } else {
            const isInCartDrawer = this.dom.trigger.classList.contains('in-cart-drawer');
            this.dom.text.textContent = this.text.submit;


            if (errorData != null) {
                return this.errorHandler({ errorData: errorData })
            }


            if (isInCartDrawer) {
                this.dom.text.textContent = this.text.submitted
                this.addProduct = false;
            } else {
                this.addProduct = true;
            }
        }
    }

    eventListeners() {

        /**We don't want eventlisteners for triggers inside the cart, because they get reloaded on every card:update */
        if (this.settings.isAside) {

            document.addEventListener('product:removed', (e) => {
                /**
                 * Only needs the items
                 */
                const cartItems = e.detail.cart.items === undefined ? null : { 'items': e.detail.cart.items };
                this.checkIfInCart({ cartItems: cartItems })
            })

            document.addEventListener('cart-addon:added', (e) => {
                /**
                 * Only needs the items
                 */

                // console.log(`e: `, e);
                const cartItems = e.detail.cart.items === undefined ? null : { 'items': e.detail.cart.items };
                this.checkIfInCart({ cartItems: cartItems })
            })
        }
    }

    errorHandler({ errorData }) {

        switch (errorData.status) {
            case 422: //Not enough inventory  
                this.dom.text.textContent = this.text.soldOut
                this.addProduct = false;
                this.dom.trigger.disabled = true

                this.errorAlertMessage({ errorData });

                break;
        }
    }

    errorAlertMessage({ errorData }) {
        setTimeout(() => {
            alert(errorData.description)
        }, 400);
    }

    addToCart() {
        const formData = { items: [{ 'id': this.settings.id, 'quantity': 1 }] };

        fetch('/cart/add.js', {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                return response.json().then(data => {
                    if (response.ok) {
                        document.dispatchEvent(new CustomEvent('product:added', {
                            bubbles: true,
                            detail: {
                                data: data,
                                variant: this.settings.id,
                                quantity: 1
                            }
                        }));

                        getCart();

                    } else {
                        this.errorHandler({ errorData: data });
                    }
                })

            }).catch((error) => {
                console.error('Error:', error);
            });
    }

    removeFromCart() {
        const lineItem = document.querySelector(`.CartItem__Remove[data-variant-id="${ this.settings.id }"]`);
        if (lineItem) {
            lineItem.click();
        } else {
            console.warn('item not found');
        }
    }
}


function getCart() {
    fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        },
    }).then((response) => {
        return response.json().then((data) => {
            document.dispatchEvent(new CustomEvent('cart-addon:added', {
                bubbles: true,
                detail: {
                    cart: data
                }
            }));
        })
    })
}


function initAddonProducts() {
    const addonProducts = document.querySelectorAll('.js-addon-product.js-init');
    addonProducts.forEach(addon_product => {
        void new AddonProduct(addon_product);
    });
}


initAddonProducts();


document.addEventListener('cart:updated', () => {

    initAddonProducts();
})


function getScrollPosition({ elem, position = "x" }) {
    let scrollValue = 0;

    if (position === 'x') {
        scrollValue = elem.scrollLeft;
    } else if (position === 'y') {
        scrollValue = elem.scrollTop;
    }
    return scrollValue;
}


(function() {

    let cartAddonsInlineVerticalScrollPosition = 0;
    let cartAddonsAsideHorizontalScrollPosition = 0;


    function getCartAddonsScrollPosition() {
        const cartAddonsInline = document.querySelector('.cart-addons--inline .cart-addons__container');
        const cartAddonsAside = document.querySelector('.cart-addons--aside .cart-addons__container');

        if (cartAddonsInline && cartAddonsAside) {
            cartAddonsInlineVerticalScrollPosition = getScrollPosition({ elem: cartAddonsInline, position: 'x' });
            cartAddonsAsideHorizontalScrollPosition = getScrollPosition({ elem: cartAddonsAside, position: 'y' });
        }
    }


    function setCartAddonsScrollPosition() {
        const cartAddonsInline = document.querySelector('.cart-addons--inline .cart-addons__container');
        const cartAddonsAside = document.querySelector('.cart-addons--aside .cart-addons__container');

        if (cartAddonsInline && cartAddonsAside) {
            cartAddonsInline.scrollLeft = cartAddonsInlineVerticalScrollPosition;
            cartAddonsAside.scrollTop = cartAddonsAsideHorizontalScrollPosition;
        }
    }


    document.addEventListener('cart:updated', () => {
        setCartAddonsScrollPosition();
    })

    document.addEventListener('product:changed', () => {
        getCartAddonsScrollPosition();
    })

    document.addEventListener('product:removed', () => {
        getCartAddonsScrollPosition();
    })

    document.addEventListener('cart-addon:added', () => {
        getCartAddonsScrollPosition();
    })

})();




